/* eslint-disable */
import Layout from '@/layout/index.vue';

const routes = {
  // ------------------------------------ 基本设置 ---------------------------------------
  // 角色管理
  roleMag: () => import(/* webpackChunkName: "RoleMag" */ '@/views/page/RoleMag/index'),
  // 用户管理
  userMag: () => import(/* webpackChunkName: "UserMag" */ '@/views/page/UserMag/index'),
  // 操作日志
  operationLog: () => import(/* webpackChunkName: "OperationLog" */ '@/views/page/OperationLog/index'),
  // 浏览记录
  browsingHistory: () => import(/* webpackChunkName: "BrowsingHistory" */ '@/views/page/BrowsingHistory/index')
};

export const baseSettingRoute = [
  {
    path: '/baseSetting',
    component: Layout,
    name: 'baseSetting',
    isMenu: true,
    redirect: { name: 'Arrive' },
    meta: { title: '用户中心', icon: 'menu_user' },
    children: [
      {
        path: 'userMag',
        name: 'userMag',
        component: routes['userMag'],
        meta: { title: '用户管理'}
      },
      {
        path: 'roleMag',
        name: 'roleMag',
        component: routes['roleMag'],
        meta: { title: '角色管理'}
      },
      {
        path: 'operationLog',
        name: 'operationLog',
        component: routes['operationLog'],
        meta: { title: '操作日志'}
      },
      // {
      //   path: 'browsingHistory',
      //   name: 'browsingHistory',
      //   component: routes['browsingHistory'],
      //   meta: { title: '浏览记录'}
      // }
    ]
  }
];
